module.exports = "<app-navbar></app-navbar>\n\n<main>\n  <app-central-display></app-central-display>\n</main>\n\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jessepinuelas/Development/jesse/freeground.io/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main